import { ADMINURL } from "helpers/constant";
import { callApi } from "Apis";
import { UTILSURL } from "helpers/constant";

export async function userLogIn(data) {
  try {
    const response = await callApi({ url: ADMINURL.SIGN_IN, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

//forgot password api
export async function forgotPassword(data) {
  try {
    const response = await callApi({ url: ADMINURL.FORGOT_PASSWORD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

//reset password api
export async function resetPassword(data) {
  try {
    const response = await callApi({ url: ADMINURL.RESET_PASSWORD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}
//logout api
export async function logOut() {
  try {
    const response = await callApi({ url: ADMINURL.SIGN_OUT, method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}

//Update Profile api...
export async function updateProfile(data) {
  try {
    const response = await callApi({ url: ADMINURL.UPDATE_PROFILE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}

//User Profile api...
export async function userProfile() {
  try {
    const response = await callApi({ url: ADMINURL.PROFILE, method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Change Password api...
export async function changePassword(data) {
  try {
    const response = await callApi({ url: ADMINURL.CHANGE_PASSWORD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

//Image Upload api...
export async function imageUpload(data) {
  try {
    const response = await callApi({ url: UTILSURL.UPLOAD_MULTIPLE, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

//Remove Image Api..
export async function removeImage(data) {
  try {
    const response = await callApi({ url: UTILSURL.REMOVE_IMAGE, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}
